import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ESTUDIOS_MEDICOS_ESTADOS } from '../../../../utils/constants';
import { cambiarEstadoEstudiosMedicos, enviarEstudioImagen, enviarInformeConImagen, getEstadosEstudiosMedicos, getInformesMedicos } from '../../../../actions/turnos/estudiosMedicos';


const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    padding: 10,
  },
});


export const AdministrarMenu = (props) => {

  const dispatch = useDispatch();
  const classes = useStyles();

  const {
    estudioMedicoSeleccionado = {},
    estados,
    informes = []
  } = useSelector((state) => state.estudiosMedicos);

  useEffect(() => {
    dispatch(getEstadosEstudiosMedicos());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getInformesMedicos(estudioMedicoSeleccionado?.idAgenda));
  }, [dispatch]);

  const onClickCambiarEstado = (idEstado) => {
   const data = {
    id: estudioMedicoSeleccionado?.id,
    idEstado : idEstado
   }
   dispatch(cambiarEstadoEstudiosMedicos(data, props.closeModalAuditar, props.filtros))
  }

  const enviarInfConImagen = (idAgenda) => {
    dispatch(enviarInformeConImagen(idAgenda, props.closeModalAuditar, props.filtros, estudioMedicoSeleccionado?.id))
  }

  const enviarImagenEstudio = (idAgenda) => {
    dispatch(enviarEstudioImagen(idAgenda, props.closeModalAuditar, props.filtros, estudioMedicoSeleccionado?.id))
  }

  console.log(informes)

  return (
    <React.Fragment>
      <Grid container className={classes.root} justify="center" spacing={1}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            style={{
              textAlign: "center",
              margin: "1.5rem 0",
            }}
          >
            Cambiar Estado:
          </Typography>
          {
            Array.isArray(estados) && estados.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  flexWrap: "wrap",
                }}
              >
                {estados
                  ?.filter(
                    (estado) =>
                      estado.id !== estudioMedicoSeleccionado?.idEstado && estado.id !== ESTUDIOS_MEDICOS_ESTADOS.ENVIADOS
                  )
                  .map((estado) => {
                    return (
                      <Button
                        key={estado.id.toString()}
                        style={{
                          margin: "0.5rem",
                          flexBasis: "30%",
                          backgroundColor: "green",
                          color: "white",
                        }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          onClickCambiarEstado(estado.id);
                        }}
                      >
                        {estado.descripcion}
                      </Button>
                    );
                  })}
              </div>
            )
          }
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            style={{
              textAlign: "center",
              margin: "1.5rem 0",
            }}
          >
            Acciones:
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              flexWrap: "wrap",
            }}
          >
            {(estudioMedicoSeleccionado?.idEstado === ESTUDIOS_MEDICOS_ESTADOS.PENDIENTES_ESTUDIO || estudioMedicoSeleccionado?.idEstado === ESTUDIOS_MEDICOS_ESTADOS.ENVIADOS ) &&
              <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "orange",
                  color: "white",
                }}
                variant="contained"
                color="secondary"
                onClick={() => {
                  enviarImagenEstudio(estudioMedicoSeleccionado?.idAgenda);
                }}
              >
                {estudioMedicoSeleccionado?.enviado ? "REENVIAR SIN INFORME" : "ENVIAR SIN INFORME"}
              </Button>
            }
            {(estudioMedicoSeleccionado?.idEstado === ESTUDIOS_MEDICOS_ESTADOS.PENDIENTES_INFORME || estudioMedicoSeleccionado?.idEstado === ESTUDIOS_MEDICOS_ESTADOS.ENVIADOS ) &&
            informes.length > 0 && 
              <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "orange",
                  color: "white",
                }}
                variant="contained"
                color="secondary"
                onClick={() => {
                  enviarInfConImagen(estudioMedicoSeleccionado?.idAgenda);
                }}
              >
                {informes[0]?.enviado === true ? "REENVIAR CON INFORME" : "ENVIAR CON INFORME"}
              </Button>
            }
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
